export const GET_ALL_DOGS = "GET_ALL_DOGS ";
export const GET_DOG = "GET_DOG";
export const FILTER = "FILTER";
export const ORDER = "ORDER";
export const GET_TEMPS = "GET_TEMPS";
